import React, { Component } from 'react';
import * as Styles from './Styles';

type Props = {
	label: string;
	onClick: () => void;
	active: boolean;
};

type State = {};

class Tab extends Component<Props, State> {
	state = {};

	render() {
		return (
			<Styles.PickerTabWrapper
				active={this.props.active}
				onClick={this.props.onClick}
			>
				{this.props.label}
			</Styles.PickerTabWrapper>
		);
	}
}

export default Tab;
